// import "./static/css/bootstrap.min.css"
// // import "bootstrap/dist/js/bootstrap.min.js"
// import "./static/css/fontawesome.css"
// import "./static/css/screen.css"
// import "./static/css/developer.css"
const React = require("react")

const { LoadingProvider } = require("./src/context/LoadingContext")
const { AuthProvider } = require("./src/context/AuthContext")
const { UserDetailsProvider } = require("./src/context/UserContext")
const { DiagnoseProvider } = require("./src/context/DiagnoseContext")
const { CreateReportProvider } = require("./src/context/CreateReportContext")
const {
  ManualTroubleShootingProvider,
} = require("./src/context/ManualTroubleShoot")

exports.wrapRootElement = ({ element }) => {
  return (
    <LoadingProvider>
      <AuthProvider>
        <UserDetailsProvider>
          <DiagnoseProvider>
            <CreateReportProvider>
              <ManualTroubleShootingProvider>
                {element}
              </ManualTroubleShootingProvider>
            </CreateReportProvider>
          </DiagnoseProvider>
        </UserDetailsProvider>
      </AuthProvider>
    </LoadingProvider>
  )
}
